import { logger } from "./logger";

export const error = (message: string, ...params: any[]): never => {
  logger.error(message, ...params);
  throw new Error(`[Orie SDK] ${message}`);
};
